import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';

import pageConfig from '../../config/page.config';
import { changeHead } from '../../redux/head/headActions';
import { setMailInfo, sendMail } from '../../redux/contact/contactActions';
import { MHero } from '../../components/molecules';
import { OCategoriePreview, OContactHouseHold, ODynamicStory } from '../../components/organisme';
import {
	FAQImage,
	herstellingenV1,
	herstellingenV2,
} from '../../assets/images/images';

const mapStateToProps = state => ({
	faq: state.content.faq,
	testimonies: state.content.testimonies,
});

class RepairsPage extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			familyName: '',
			name: '',
			tel: '',
			email: '',
			subject: '',
			message: '',
			isFormValid: false,
		};

		this.bindHandles();
	}

	componentDidMount() {
		this.props.changeHead({
			id: pageConfig.repairs.id,
			title: this.props.intl.formatMessage({ id: pageConfig.repairs.title }),
			description: this.props.intl.formatMessage({ id: pageConfig.repairs.description }),
			showSocialMedia: true,
		});
	}

	bindHandles() {
		this.handleFormChange = this.handleFormChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	handleFormChange(value) {
		this.props.setMailInfo({ ...value });
	}

	handleSubmit() {
		if (this.state.isFormValid) {
			this.props.sendMail();
		}
	}

	render() {
		return (
			<section className="household-wrapper">
				<MHero
					img={FAQImage}
					currentPage="BREAD_CRUMB.REPAIRS"
					className=""
				/>
				<div className="section-lg layout-body household-home-story">
					<ODynamicStory
						img={herstellingenV1}
						description="REPAIRS.ARTICLE_PRIMARY.DESCRIPTION"
						className="t-gap--bottom-xx"
					/>
					<OCategoriePreview
						items={pageConfig.repairs.productPreviewList}
						className="t-gap--bottom-xl"
					/>
					<ODynamicStory
						img={herstellingenV2}
						direction="reverse"
						description="REPAIRS.ARTICLE_SECONDARY.DESCRIPTION"
					/>
				</div>
				<article className="section-md layout-contact">
					<h2 className="t-gap--bottom-sm">
						<FormattedMessage id="REPAIRS.TITLE.CONTACT_FORM" />
					</h2>
					<OContactHouseHold
						familyName={this.state.familyName}
						name={this.state.name}
						tel={this.state.tel}
						email={this.state.email}
						subject={this.state.subject}
						message={this.state.message}
						isFormValid={this.state.isFormValid}
						onChange={this.handleFormChange}
						onSubmit={this.handleSubmit}
					/>
				</article>
			</section >
		);
	}
}

RepairsPage.propTypes = {
	changeHead: PropTypes.func.isRequired,
	setMailInfo: PropTypes.func.isRequired,
	sendMail: PropTypes.func.isRequired,
};

export default withRouter(connect(mapStateToProps, {
	setMailInfo,
	sendMail,
	changeHead,
})(injectIntl(RepairsPage)));



// WEBPACK FOOTER //
// ./src/pages/household/repairs.page.js